import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './lib/ThemeProvider';
import { Layout } from './components/Layout';
import { ToastViewport } from './components/ui/Toast';
import { ErrorBoundary } from './components/ErrorBoundary';
import { UpdateBanner } from './components/UpdateBanner';
import { LoginPage } from './pages/auth/LoginPage';
import { RegisterFamilyPage } from './pages/auth/RegisterFamilyPage';
import { DashboardPage } from './pages/DashboardPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { GoalsPage } from './pages/GoalsPage';
import { MyPortfolioPage } from './pages/MyPortfolioPage';
import { SettingsPage } from './pages/SettingsPage';
import { BudgetsPage } from './pages/BudgetsPage';
import { CategoriesPage } from './pages/CategoriesPage';
import { RequireAuthAndFamily, RedirectIfAuthenticated } from './features/auth/AuthGate';
import { useAuthSync } from './features/auth/useAuthSync';
import { useDataSync } from './features/dataSync';

function AppShell({ children }: { children: React.ReactNode }) {
  useAuthSync();
  useDataSync();
  return <>{children}</>;
}

export function App() {
  return (
    <ErrorBoundary>
    <ThemeProvider>
      <HashRouter>
        <AppShell>
          <Routes>
            <Route element={<RedirectIfAuthenticated />}>
              <Route path="/login" element={<LoginPage />} />
            </Route>

            <Route path="/register-family" element={<RegisterFamilyPage />} />

            <Route element={<RequireAuthAndFamily />}>
              <Route element={<Layout />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/goals" element={<GoalsPage />} />
                <Route path="/budgets" element={<BudgetsPage />} />
                <Route path="/myportfolio" element={<MyPortfolioPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/categories" element={<CategoriesPage />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <ToastViewport />
          <UpdateBanner />
        </AppShell>
      </HashRouter>
    </ThemeProvider>
    </ErrorBoundary>
  );
}
